import { observer } from "mobx-react"
import { Page, PureLogo, Header, useStore, Footer } from "@features/common"
import { serverSidePagePrepare } from "@lib/hooks"
import { RouterLink } from "@lib/routing"
import { scrollToTop } from "@lib/scroll"
import { IconHamburger } from "@lib/icons"
import {
  AboutUsLogo,
  AboutUsLogoRU,
  HeroComponent,
  MissionComponent,
  WhatWeAreIntoComponent,
  PrivacyAndSafetyComponent,
  NewsAndJoinComponent,
} from "@features/about-us-page"
import { useSmartBanner } from "@features/smart-banner"

export const getServerSideProps = serverSidePagePrepare({
  callback: async ({ Models }) => {
    await Models.TeamPageModel.getTeamPage()
    await Models.GlobalModel.getSmartBanner()
  },
})

const AboutUsPage = observer(function TeamPage() {
  const {
    GlobalModel: { openMenu, getTemplate, lang },
    TeamPageModel: { getTemplate: getTeamTemplate },
  } = useStore()
  const { smartBanner } = useSmartBanner()

  const title = getTemplate("about.title")
  const metaTitle = getTeamTemplate("about.metaTitle") || title
  const description = getTeamTemplate("about.metaDescription")
  const seoH1 = getTeamTemplate("about.seoH1.title")

  return (
    <Page
      meta={{
        title,
        metaTitle,
        description,
      }}
      className="overflow-x-hidden"
      footer={<Footer bgColor="black" />}
      smartBanner={smartBanner}
      header={
        <Header
          theme="black"
          logo={
            <RouterLink
              uri="/about-us"
              onClick={() => scrollToTop()}
              data-test-id="header__pure_logo"
              aria-label="root"
              className="mt-4 mb-3 tablet-m:mt-[20px] tablet-m:mb-[18px]"
            >
              <div className="shrink-0 flex items-stretch h-4 tablet-m:h-7">
                <PureLogo className="shrink-0 block h-full w-auto tablet:h-full text-white pr-2 tablet-m:pr-4" />
                {lang === "ru" ? <AboutUsLogoRU /> : <AboutUsLogo />}
              </div>
            </RouterLink>
          }
          languageSwitcher={null}
          navigationOpener={
            <button
              onClick={openMenu}
              data-test-id="header__menu_button"
              aria-label="menu"
            >
              <IconHamburger className="w-8 h-8 text-white" />
            </button>
          }
        />
      }
      alternativeHeader
      seoH1={seoH1}
    >
      <HeroComponent />
      <MissionComponent />
      <WhatWeAreIntoComponent />
      <PrivacyAndSafetyComponent />
      <NewsAndJoinComponent />
    </Page>
  )
})

export default AboutUsPage
